export default "__VITE_ASSET__Cde9o4et__"